'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var MoveArrows = function MoveArrows(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({}, props, {
    viewBox: "0 0 24 24"
  }), React__default["default"].createElement("polygon", {
    className: "cls-1",
    points: "12.49 22.13 12.49 16.17 11.51 16.17 11.51 22.13 8.78 19.39 8.09 20.09 12 24 15.91 20.09 15.22 19.39 12.49 22.13"
  }), React__default["default"].createElement("polygon", {
    className: "cls-1",
    points: "8.09 3.92 8.78 4.61 11.51 1.87 11.51 7.83 12.49 7.83 12.49 1.87 15.22 4.61 15.91 3.92 12 0 8.09 3.92"
  }), React__default["default"].createElement("polygon", {
    className: "cls-1",
    points: "4.61 8.78 3.92 8.09 0 12 3.92 15.91 4.61 15.22 1.87 12.49 7.83 12.49 7.83 11.51 1.87 11.51 4.61 8.78"
  }), React__default["default"].createElement("polygon", {
    className: "cls-1",
    points: "20.09 8.09 19.39 8.78 22.13 11.51 16.17 11.51 16.17 12.49 22.13 12.49 19.39 15.22 20.09 15.91 24 12 20.09 8.09"
  }));
};

var MoveArrows$1 = iconStyles()(MoveArrows);

module.exports = MoveArrows$1;
